import { useSearchParams } from 'react-router-dom'

import { VoiceClient } from 'modules/ai_voice/components/VoiceClient'
import { useVoiceSession } from 'modules/ai_voice/providers/voiceSession'

export function VoiceModeRenderer() {
  const { params } = useVoiceSession()
  const [searchParams] = useSearchParams()
  const preview = searchParams.get('preview') === 'true'

  return <VoiceClient agent={params.agent} task={params.task} preview={preview} />
}
